import type { AlignerFormData } from '@witmetrics/utils';
import { UNISON_PROJECT_TYPE_ID } from '@witmetrics/utils/constants';
import type {
  BleachingFormParams,
  NightguardFormParams,
  OrthoFormParams,
  RetainerFormParams,
} from '@witmetrics/unison-core';
import { useNewCase } from '@/providers/NewCaseProvider';
import Title from '@/components/Title';
import RetainerForm from './RetainerForm';
import BleachingForm from './BleachingForm';
import NightguardForm from './NightguardForm';
import AlignerForm, { type AlignersFormProps } from './AlignerForm';
import OrthoForm from './OrthoForm';
import { classes } from './utils';

const { RETAINERS, BLEACHING_TRAY, NIGHTGUARD, ALIGNERS, ORTHO_MODELS } =
  UNISON_PROJECT_TYPE_ID;

export default function CaseSettingsStep() {
  const {
    projectTypeId,
    params,
    selectedTeeth,
    onUpdateParams,
    onUpdateSelectedTeeth,
  } = useNewCase();

  const handleUpdateAligners: AlignersFormProps['onChange'] = (
    updatedParams,
    updatedTeeth
  ) => {
    onUpdateParams(updatedParams);
    onUpdateSelectedTeeth(updatedTeeth);
  };

  if (projectTypeId === RETAINERS) {
    return (
      <RetainerForm
        params={params as RetainerFormParams}
        onChange={onUpdateParams}
      />
    );
  }
  if (projectTypeId === BLEACHING_TRAY) {
    return (
      <BleachingForm
        params={params as BleachingFormParams}
        onChange={onUpdateParams}
      />
    );
  }
  if (projectTypeId === NIGHTGUARD) {
    return (
      <NightguardForm
        params={params as NightguardFormParams}
        onChange={onUpdateParams}
      />
    );
  }
  if (projectTypeId === ORTHO_MODELS) {
    return (
      <OrthoForm params={params as OrthoFormParams} onChange={onUpdateParams} />
    );
  }
  if (projectTypeId === ALIGNERS) {
    return (
      <AlignerForm
        params={params as AlignerFormData}
        selectedTeeth={selectedTeeth}
        onChange={handleUpdateAligners}
      />
    );
  }
  // TODO
  return (
    <div className={classes.wrapper}>
      <div className={classes.column}>
        <Title size="sm">Customize the Case Settings</Title>
        <p className={classes.instructions}>
          No custom settings available for this case type.
        </p>
      </div>
    </div>
  );
}
